<template>
  <div :style="{ background: '#FFFFFF', height: '100vh' }">
    <OnboardingTopBar />
    <div class="content">
      <!-- Start your arnergy journey -->
      <div class="choose-package">
        <div class="welcome">{{ title }}</div>
        <div class="subtext">{{ description }}</div>

        <div v-if="loading" class="loading">
          <a-spin />
        </div>
        <slot v-else></slot>

        <div v-if="subtext" class="subtext">
          {{ subtext }}
        </div>

        <div class="buttons">
          <OnboardingButton
            class="back"
            v-if="disableBackButton === false"
            text="Back"
            type="prev"
            @onButtonClick="$router.go(-1)"
          />
          <OnboardingButton
            class="continue"
            :style="{ opacity: 0.2 }"
            type="next"
            v-if="!canContinue"
            text="Continue"
            @onButtonClick="null"
          />
          <OnboardingButton
            class="continue"
            :style="{ opacity: 1 }"
            type="next"
            v-else
            text="Continue"
            @onButtonClick="onButtonClick"
          />
        </div>

        <!-- <div class="package">
          <div v-for="item in packages" :key="item.id">
            <onboarding-select-button
              :ID="item.id"
              :title="item.name"
              :description="item.productDescription"
              :image="item.url_image"
              :isActive="activePackageType && activePackageType.id == item.id"
              @setActive="updateActivePackageType(item)"
            />
          </div>
        </div> -->
      </div>

      <!-- Those Images -->
      <div class="right-image">
        <template v-if="isLVILocation">
          <div class="lvi-description">
            {{ lviDescription }}
          </div>
          <img
            :src="require('@/assets/img/orange-triangle.svg')"
            class="polygon"
          />
        </template>
        <template v-else>
          <div class="description">
            {{ imageDescription }}
          </div>
          <img :src="require('@/assets/img/polygon.svg')" class="polygon" />
        </template>

        <img :src="imageUrl" class="man-woman" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";
// import ButtonOnboardingPackage from "../kitchen/ButtonOnboardingPackage";
// import OnboardingSelectButton from "../kitchen/OnboardingSelectButton";
// import SideIndicator from "../kitchen/Onboarding/SideIndicator.vue";
// import ModalCalculate from "../kitchen/Onboarding/ModalCalculate";
// import ModalMain from "../kitchen/Onboarding/ModalMain.vue";
// import MoneyFormat from "vue-money-format";
import OnboardingButton from "@/components/OnboardingButton.vue";
import OnboardingTopBar from "@/components/OnboardingTopBar.vue";
import { Spin } from "ant-design-vue";

export default {
  name: "OnboardingLayout",
  computed: {},
  components: { OnboardingTopBar, OnboardingButton, "a-spin": Spin },
  props: {
    title: {
      type: String,
      default: "Start your Arnergy Journey!",
    },
    subtext: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default:
        "Join the thousands of Arnergy users all over Africa who are enjoying unlimited answers with our solar solution today.",
    },
    imageDescription: {
      type: String,
      default: "Welcome!",
    },
    imageUrl: {
      type: String,
      default: require("@/assets/img/man-woman.png"),
    },
    disableBackButton: {
      type: Boolean,
      default: false,
    },
    canContinue: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isLVILocation: {
      type: Boolean,
      default: false,
    },
    lviDescription: {
      type: String,
      default:
        "if you run into issues during the onboarding process, please contact any of these persons tobi@sunfi.co, juba@sunfi.co, aisha.iyemifokhae@sunfi.co",
    },
  },
  data() {
    return {};
  },
  methods: {
    onButtonClick() {
      this.$emit("onButtonClick");
    },
  },
  async mounted() {},
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  width: 100%;
  padding: 0rem 14rem;
  font-family: "DM Sans";
  background: #ffffff;

  @media screen and (max-width: 600px) {
    padding: 0rem 2rem;
    flex-direction: column-reverse;
  }
}

.buttons {
  display: flex;
  gap: 20px;
  align-items: center;
  margin: 20px 0;
}

.choose-package {
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}

.button {
  border: 1px solid #0892d0;
  border-radius: 5px;
  padding: 7px 10px;
}

.welcome {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 39px;
  color: #0892d0;
  margin-bottom: 2.1rem;
}

.subtext {
  font-family: "DM Sans";
  max-width: 58.1rem;
  width: 100%;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #727272;
  margin-bottom: 2.7rem;
}

.choice-type {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 2.7rem;
  color: #fe7a11;
}

.boxes {
  display: flex;
  margin-bottom: 2.7rem;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}

.package {
  display: flex;
  margin-bottom: 2.7rem;
}

.right-image {
  display: flex;
  flex-direction: column;
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.lvi-description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #fef3e9;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #e66e08;
}

.man-woman {
  margin-bottom: 9rem;
}

.continue {
  display: block;
  margin-left: auto;
  margin-right: 0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}

.loading {
  min-height: 150px;
  display: grid;
  width: 50%;
  place-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/onboarding-layout.vue